<template>
    <div class="log-container">
      <h3>Activity Log</h3>
      <div class="log-entries">
        <div v-for="(log, index) in logs" :key="index" class="log-entry" :class="log.type">
          <span class="log-time">{{ log.time }}</span>
          <span class="log-message">{{ log.message }}</span>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'LogViewer',
    props: {
      logs: {
        type: Array,
        default: () => []
      }
    }
  }
  </script>
  
  <style scoped>
  .log-container {
    margin-bottom: 30px;
  }
  
  .log-entries {
    height: 200px;
    overflow-y: auto;
    border: 1px solid var(--border-color);
    border-radius: 4px;
    padding: 10px;
    background-color: #f9f9f9;
  }
  
  .log-entry {
    padding: 5px;
    border-bottom: 1px solid #eee;
    font-size: 13px;
  }
  
  .log-entry:last-child {
    border-bottom: none;
  }
  
  .log-time {
    color: var(--text-light);
    margin-right: 10px;
  }
  
  .log-entry.error {
    color: var(--danger-color);
  }
  
  .log-entry.warning {
    color: #ff9800;
  }
  
  .log-entry.success {
    color: var(--primary-color);
  }
  </style>